import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { AdminApiActions, AdminPageActions } from '@appState/actions/admin';
import * as AppState from '@appState/reducers';
import { IShareholder } from '@appShared/interfaces/[Model-based]/shareholder.interface';

export interface AdminState {
  selectedShareholder: IShareholder;
  errorSetSelectedShareholder: string;
}

export interface State extends AppState.State {
  admin: AdminState;
}

const intialAdminState: AdminState = {
  selectedShareholder: null,
  errorSetSelectedShareholder: ''
};

export const getAdminState = createFeatureSelector<AdminState>('admin');

export const adminReducer = createReducer<AdminState>(
  intialAdminState,
  on(AdminPageActions.setSelectedShareholder, (state, action): AdminState => {
    return {
      ...state,
      selectedShareholder: action.shareholder
    };
  }),
  on(AdminApiActions.loadShareholderSuccess, (state, action): AdminState => {
    return {
      ...state,
      selectedShareholder: action.shareholder,
      errorSetSelectedShareholder: ''
    };
  }),
  on(AdminApiActions.loadShareholderFailure, (state, action): AdminState => {
    return {
      ...state,
      selectedShareholder: null,
      errorSetSelectedShareholder: action.error
    };
  })
);
